import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// WordPress取得失敗時のフォールバック（現在の固定値と同一）
// 住所は会社概要の1行目のみをフッターに表示する
const FALLBACK_FOOTER = {
  address: '東京都新宿区新宿2丁目12-13 2F',
  tel: '03-5050-4341',
};

function Footer() {
  const navigate = useNavigate();
  // 初期値はフォールバック（＝現在の表示）。fetch完了後にWordPressの値へ差し替え
  const [info, setInfo] = useState(FALLBACK_FOOTER);

  // 会社概要と同じ /wp/v2/company から住所・TELを取得（WordPressで編集すると両方に反映）
  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const response = await axios.get(
          'https://chaln.co.jp/wp-json/wp/v2/company',
          {
            headers: { 'Content-Type': 'application/json' },
            timeout: 10000,
          }
        );

        const data = response.data || {};
        const next = {};
        if (typeof data.address === 'string' && data.address.trim() !== '') {
          // 会社概要は複数行。フッターは1行目のみ使用
          next.address = data.address.replace(/\r\n?/g, '\n').split('\n')[0].trim();
        }
        if (typeof data.tel === 'string' && data.tel.trim() !== '') {
          next.tel = data.tel.trim();
        }
        setInfo((prev) => ({ ...prev, ...next }));
      } catch (error) {
        console.error('Error fetching company info (footer):', error);
        // エラー時はフォールバック（初期値）のまま表示
      }
    };

    fetchInfo();
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    const offset = 200; // 固定ヘッダーの高さ
    const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  const handlePrivacyPolicyClick = () => {
    navigate('/privacy-policy');
  };

  return (
    <footer className="mt-20 py-8 w-full bgm-gray-400/80 p-6 text-white text-center shadow-inner backdrop-blur-xl border-t border-cyan-200/10">
      <div className="w-full max-w-6xl mx-auto flex flex-col md:flex-row md:justify-between items-center gap-4 px-4">
        {/* 左側：会社情報 */}
        <div className="text-sm md:text-base space-y-1 text-orange-500 font-semibold">
          <img
            src={`${process.env.PUBLIC_URL}/image/Chaln_white.png`}
            alt="株式会社シャルン"
            className="h-10 md:h-12 object-contain"
          />
          <div>{info.address}</div>
          <div>TEL: {info.tel}</div>
          <div className="mt-10">
            <a
              href="https://privacymark.jp/"
              target="_blank"
              rel="noopener noreferrer"
              className="block hover:scale-105 transition-transform"
            >
              <img
                src={`${process.env.PUBLIC_URL}/image/pMark.png`}
                alt="プライバシーマーク"
                className="mt-10 h-6 md:h-10 object-contain opacity-80 hover:opacity-100 transition-opacity 
              mx-auto md:mx-0"
              />
            </a>
          </div>
        </div>
        {/* 右側：ナビゲーション */}
        <nav className="flex flex-col gap-2 justify-center mt-4 md:mt-0">
          <button onClick={() => scrollToSection('philosophy')} className="hover:text-orange-500 transition font-bold">About</button>
          <button onClick={() => scrollToSection('performance')} className="hover:text-orange-500 transition font-bold">Service</button>
          <button onClick={() => scrollToSection('message')} className="hover:text-orange-500 transition font-bold">Message</button>
          <button onClick={() => scrollToSection('recruit')} className="hover:text-orange-500 transition font-bold">Recruit</button>
          <button onClick={() => scrollToSection('company')} className="hover:text-orange-500 transition font-bold">Company</button>
          <button onClick={() => scrollToSection('news')} className="hover:text-orange-500 transition font-bold">News</button>
          <button onClick={() => scrollToSection('contact')} className="hover:text-orange-500 transition font-bold">Contact</button>
          <button onClick={handlePrivacyPolicyClick} className="hover:text-orange-500 transition font-bold">Privacy Policy</button>
        </nav>
      </div>
      {/* <div className="mt-6 text-xs text-cyan-200/60 tracking-widest">
        &copy; Copyright © Chaln All Rights Reserved.
      </div> */}
    </footer>
  );
}

export default Footer;